import React from 'react';
import { Table, Button, Pagination } from 'semantic-ui-react';
import styles from './Support.module.scss';
import SupportModal from '../SupportModal/SupportModal';
import api from '../../api';
import Config from '../../constants/Config';
import moment from 'moment';

const Support = React.memo(() => {
  const [isShow, setIsShow] = React.useState(false);
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [supportData, setSupportData] = React.useState({
    list: [],
    total: 0,
  });

  const handlePageChange = (e, { activePage }) => {
    setCurrrentSkip(activePage);
  };
  const onClose = () => {
    setIsShow(false);
  };

  const init = () => {
    api
      .getSupport({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
      })
      .then((res) => {
        setSupportData({ list: res.item, total: res.total });
      });
  };

  const onCreate = (id) => {
    api
      .createSupport({
        id,
      })
      .then(() => {
        init();
        onClose();
      });
  };

  React.useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSkip]);
  return (
    <>
      {isShow && <SupportModal onCreate={onCreate} onClose={onClose} />}
      <div className={styles.app}>
        <div className={styles.table}>
          <div className={styles.box}>
            <Button
              positive
              content="新增支持账号"
              onClick={() => {
                setIsShow(true);
              }}
            />
          </div>
          <Table celled unstackable fixed sortable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={2}>用户名</Table.HeaderCell>
                <Table.HeaderCell width={2}>姓名</Table.HeaderCell>
                <Table.HeaderCell width={2}>创建人</Table.HeaderCell>
                <Table.HeaderCell width={4}>创建时间</Table.HeaderCell>
                <Table.HeaderCell width={14}>操作内容</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!!supportData.list.length &&
                supportData.list.map((item) => (
                  <Table.Row key={item.id}>
                    <Table.Cell>{item.userId.username}</Table.Cell>
                    <Table.Cell>{item.userId.name}</Table.Cell>
                    <Table.Cell>{item.creatorUserId.name}</Table.Cell>
                    <Table.Cell>
                      {item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                    </Table.Cell>
                    <Table.Cell>{`{"email"=>"${item.supportUserId.email}","identity"=>"${
                      item.identity || ''
                    }"}`}</Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="5" style={{ textAlign: 'right' }}>
                  <Pagination
                    activePage={currentSkip}
                    totalPages={supportData.total}
                    onPageChange={handlePageChange}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </div>
      </div>
    </>
  );
});

export default Support;
